var _desc, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "580px",
    height: "580px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "nonzero",
    clipRule: "nonzero",
    viewBox: "0 0 5800 5800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "install icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "install icon from the IconExperience.com I-Collection. Copyright by INCORS GmbH (www.incors.com).")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "curve28",
    fill: "#000000",
    d: "M700 1300l0 -1000 4400 0 0 3000 -2100 0 0 400 900 0 0 200 -2000 0 0 -200 900 0 0 -400 -2100 0 0 -1000 200 0 0 800 4000 0 0 -2600 -4000 0 0 800 -200 0zm500 3600l500 0 0 200 -500 0 0 -200zm2900 0l500 0 0 200 -500 0 0 -200zm-2700 -400l400 0 0 200 -400 0 0 -200zm600 0l200 0 0 200 -200 0 0 -200zm400 0l200 0 0 200 -200 0 0 -200zm400 0l200 0 0 200 -200 0 0 -200zm400 0l200 0 0 200 -200 0 0 -200zm400 0l200 0 0 200 -200 0 0 -200zm400 0l400 0 0 200 -400 0 0 -200zm-2100 400l2000 0 0 200 -2000 0 0 -200zm3226 400l-554 -950c-10,-33 -56,-50 -87,-50l-3170 0c-38,0 -67,16 -87,49l-554 951 4452 0zm0 200l-4452 0c-72,0 -137,-38 -173,-101 -36,-62 -36,-138 0,-200l555 -950c54,-93 151,-149 259,-149l3170 0c108,0 205,56 259,149l555 950c36,62 36,138 0,200 -36,63 -101,101 -173,101zm-4826 -3800l1659 0 -630 -629 142 -142 800 800 70 71 -70 71 -800 800 -142 -142 630 -629 -1659 0 0 -200z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall);
export default __webpack_public_path__ + "static/media/install.b798b7532161424bd217fe3e4a647525.svg";
export { ForwardRef as ReactComponent };